import React, { useEffect, useState } from "react";
import CustomInput from "../../../Components/Common/CustomInput";
import CustomButton from "../../../Components/Common/CustomButton";
import PhoneNumberInput from "../../../Components/Common/PhoneNumberInput";
import CustomSelect from "../../../Components/Common/CustomSelect";
import CustomDatePicker from "../../../Components/Common/CustomDatePicker";
import { getImageUrl } from "../../../hooks/fileUploader";
import CustomImageInput from "../../../Components/Common/CustomImageInput";
import { createProfile, editProfile } from "../../../redux/users/userSlice";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
const PersonalForm = ({
  setActiveTab,
  setFormData,
  PersonalDataForm,
  PersonalDataState,
  ProId,
}) => {
  const [formValues, setFormValues] = useState(PersonalDataState);
  const [invalidFields, setInvalidFields] = useState({});
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);
  const { singleUser,isLoading } = useSelector((state) => state.users);

  useEffect(() => {
    setFormValues(PersonalDataState);
  }, [PersonalDataState]);

  const handleChange = (name, value) => {
    setFormValues({
      ...formValues,
      [name]: value,
    });
    setInvalidFields(() => ({ ...invalidFields, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newInvalidFields = {};
    let isValid = true;
    Object.keys(formValues).forEach((key) => {
      if (key !== "userType" && formValues[key] === "") {
        newInvalidFields[key] = `Please Enter ${key}`;
        isValid = false;
      }
    });
    setInvalidFields(newInvalidFields);

    if (isValid) {
      setFormData((pre) => ({
        ...pre,
        PersonalData: { ...formValues },
      }));

      const {
        dialCode,
        phoneNumber,
        userType,
        dateOfBirth,
        ...restPersonalDetail
      } = formValues;

      const tenantId = Cookies.get("TenantId");
      const tenant = profileData?.tenants?.find((t) => t.tenantId === tenantId);
      const body = {
        phoneNumber: {
          dialCode,
          value: phoneNumber,
        },
        dob: dateOfBirth,
        ...restPersonalDetail,
      };
      const createBody = {
        ...body,
        tenants: [
          {
            tenantId: Cookies.get("TenantId"),
            tenantName: tenant?.tenantName,
            userType,
          },
        ],
      };

      // singleUser is set once this wizard has created the profile, so coming back to this step edits it.
      const existingProfileId = ProId || singleUser?._id;

      try {
        if (existingProfileId) {
          await dispatch(
            editProfile({
              body,
              id: existingProfileId,
              userId: singleUser?.userId,
            })
          ).unwrap();
        } else {
          await dispatch(
            createProfile({
              updatedFormData: createBody,
            })
          ).unwrap();
        }
        setActiveTab(() => 1);
      } catch (error) {
        console.log("Profile submission error:", error);
        toast.error(
          error?.message || "An error occurred while saving the profile"
        );
      }
    }
  };

  const handleDialCodeChange = (value) => {
    setFormValues((pre) => ({ ...pre, dialCode: value }));
  };

  const handleFileChange = async (e) => {
    try {
      const url = await getImageUrl(e);
      console.log(url, "url");
      setFormValues((pre) => ({ ...pre, imageUrl: url }));
    } catch (error) {
      console.log("Failed to upload image:", error);
    }
  };

  return (
    <form className="pb-6 h-max px-3 customScrollbar " onSubmit={handleSubmit}>
      {PersonalDataForm.length > 0 &&
        PersonalDataForm?.map((elm, index) => (
          <div key={index} className="pl-2 pb-4 border-b-2 border-slate-100">
            <div className="py-1">
              <h1 className="text-lg font-semibold text-gray-800">
                {elm.heading}
              </h1>
              <p className="text-sm text-gray-500 opacity-90">
                {elm.subHeading}
              </p>
            </div>
            <div className="px-4 mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">
              {elm.forminput
                .filter((elem) => elem.id !== "userType")
                .map((elem) =>
                  elem.id === "gender" ? (
                    <div key={elem.id} className="w-full mb-2">
                      <CustomSelect
                        id={elem.id}
                        label={elem.label}
                        value={formValues[elem.id]}
                        options={["male", "female", "other"]}
                        isInvalid={invalidFields[elem.id]}
                        onChange={handleChange}
                        required={elem.required}
                      />
                    </div>
                  ) : elem.id === "phoneNumber" ? (
                    <div key={elem.id} className="w-full mb-2">
                      <PhoneNumberInput
                        type={elem.type}
                        label={elem.label}
                        id={elem.id}
                        placeholder={elem.placeholder}
                        value={formValues[elem.id]}
                        dialCode={formValues.dialCode}
                        isInvalid={invalidFields[elem.id]}
                        onChangeDialCode={handleDialCodeChange}
                        onChangeNumber={(value) => handleChange(elem.id, value)}
                        required={elem.required}
                      />
                    </div>
                  ) : elem.type === "date" ? (
                    <div key={elem.id} className="w-full mb-2">
                      <CustomDatePicker
                        id={elem.id}
                        label={elem.label}
                        value={formValues[elem.id]}
                        isInvalid={invalidFields[elem.id]}
                        errorMessage={invalidFields[elem.id]}
                        onChange={handleChange}
                        required={elem.required}
                      />
                    </div>
                  ) : elem.type === "file" ? (
                    <div
                      key={elem.id}
                      className=" flex items-center col-span-1 md:col-span-2 lg:col-span-3 w-full max-w-[18rem] mx-auto"
                    >
                      <CustomImageInput
                        id={elem.id}
                        label={elem.label}
                        imageUrl={formValues[elem.id]}
                        isInvalid={invalidFields[elem.id]}
                        errorMessage={invalidFields[elem.id]}
                        onChange={handleFileChange}
                      />
                    </div>
                  ) : (
                    <div key={elem.id} className="w-full mb-2">
                      <CustomInput
                        type={elem.type}
                        label={elem.label}
                        id={elem.id}
                        placeholder={elem.placeholder}
                        value={formValues[elem.id]}
                        isInvalid={invalidFields[elem.id]}
                        onchange={(e) => handleChange(elem.id, e.target.value)}
                        required={elem.required}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        ))}
      <div className="flex justify-end items-center mt-6 mr-7">
        <CustomButton type="submit" text="Next" loading={isLoading}/>
      </div>
    </form>
  );
};

export default PersonalForm;
